const ROUTES = {
  login: '/login',
};

export default ROUTES;
